/**
 * Перевод статуса главной страницы в текст
 */
export enum EMainPageStatusToText {
  Published = 'Опубликована',
  UnPublished = 'Черновик',
}
